import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  remarkList: [],
  paymentResponse: null,
  recallBill: [],
  recallOrderData: null,
  recallOrderId: null,
  billItem: [],
};

const billSlice = createSlice({
  name: "bill",
  initialState,
  reducers: {
    setBill: (state, action) => {
      state.data = action.payload;
    },
    setRemark: (state, action) => {
      state.remarkList = action.payload;
    },
    setRecall: (state, action) => {
      state.recallBill = action.payload;
    },
    setPaymentResponse: (state, action) => {
      state.paymentResponse = action.payload;
    },
    setBillItem: (state, action) => {
      state.billItem = action.payload;
    },
    clearBill: (state) => {
      state.data = [];
    },
    clearRemark: (state) => {
      state.remarkList = [];
    },
    clearBillItem: (state) => {
      state.billItem = [];
    },
    setRecallOrderData: (state, action) => {
      state.recallOrderData = action.payload;
    },

    setRecallOrderId: (state, action) => {
      state.recallOrderId = action.payload;
    },
    clearRecall: (state) => {
      state.recallBill = [];
    },

    clearRecallData: (state) => {
      state.recallOrderData = null;
      state.recallOrderId = null;
    },
  },
});
export const {
  setBill,
  clearBill,
  setRemark,
  clearRemark,
  setPaymentResponse,
  clearRecall,
  setRecall,
  setRecallOrderData,
  setRecallOrderId,
  clearRecallData,
  clearBillItem,
  setBillItem,
} = billSlice.actions;

export default billSlice.reducer;
